import { Button, CircularProgress } from '@mui/material';
import { UploadButtonProps } from './UploadButton.types';

export const UploadButton = ({ disabled, uploading, onClick, className }: UploadButtonProps) => {
  return (
    <div className="upload-button-container">
      <Button disabled={disabled} variant="contained" className={className || 'upload-button'} onClick={onClick}>
        {uploading ? (
          <>
            <CircularProgress size={20} className="upload-loading-spinner" />
            Завантаження...
          </>
        ) : (
          'Завантажити'
        )}
      </Button>
    </div>
  );
};
